import { useState } from 'react'
import { ScalarValue } from './ScalarValue'

function copyStr(s: string) { navigator.clipboard.writeText(s) }

export function ValueNode({ label, value, depth = 0 }: { label: string; value: unknown; depth?: number }) {
  const isArr = Array.isArray(value)
  const isObj = typeof value === 'object' && value !== null && !isArr
  const isComplex = isArr || isObj
  const [open, setOpen] = useState(depth < 2)
  const [copied, setCopied] = useState(false)

  function handleCopy(e: React.MouseEvent, s: string) {
    e.stopPropagation()
    copyStr(s)
    setCopied(true)
    setTimeout(() => setCopied(false), 1500)
  }

  const labelEl = (
    <span className="mono" style={{ fontSize: depth === 0 ? 10 : 11, color: 'var(--fg-3)', textTransform: depth === 0 ? 'uppercase' : 'none', letterSpacing: depth === 0 ? '0.08em' : 0 }}>
      {label}
    </span>
  )

  if (isComplex) {
    const count = isArr ? (value as unknown[]).length : Object.keys(value as object).length
    const summary = `${isArr ? 'Array' : 'Object'} · ${count} ${isArr ? 'item' : 'key'}${count !== 1 ? 's' : ''}`
    return (
      <div style={{ marginBottom: depth === 0 ? 14 : 5, paddingLeft: depth > 0 ? 10 : 0, borderLeft: depth > 0 ? '1px solid var(--line-soft)' : 'none' }}>
        <div className="row" style={{ gap: 6, cursor: 'pointer', userSelect: 'none', marginBottom: 3 }} onClick={() => setOpen(o => !o)}>
          {labelEl}
          <span style={{ fontSize: 11, color: 'var(--fg-3)' }}>{open ? '▾' : '▸'} {summary}</span>
          <button className="btn btn-ghost btn-mono" style={{ fontSize: 10, padding: '0px 6px', marginLeft: 'auto', opacity: 0.5 }} onClick={e => handleCopy(e, JSON.stringify(value))}>
            {copied ? '✓' : 'copy'}
          </button>
        </div>
        {open && (
          <div style={{ marginTop: 4 }}>
            {isArr
              ? (value as unknown[]).map((item, i) => <ValueNode key={i} label={String(i)} value={item} depth={depth + 1} />)
              : Object.entries(value as Record<string, unknown>).map(([k, v]) => <ValueNode key={k} label={k} value={v} depth={depth + 1} />)
            }
          </div>
        )}
      </div>
    )
  }

  return (
    <div className="row" style={{ gap: 8, alignItems: 'flex-start', marginBottom: depth === 0 ? 14 : 5, paddingLeft: depth > 0 ? 10 : 0 }}>
      {depth === 0
        ? <div style={{ flex: 1, minWidth: 0 }}>
            <div style={{ marginBottom: 3 }}>{labelEl}</div>
            <div className="mono" style={{ fontSize: 13 }}><ScalarValue v={value} /></div>
          </div>
        : <>
            <span className="mono" style={{ fontSize: 11, color: 'var(--fg-3)', minWidth: 70, flexShrink: 0 }}>{label}</span>
            <div className="mono" style={{ fontSize: 12, flex: 1, minWidth: 0 }}><ScalarValue v={value} /></div>
          </>
      }
      <button className="btn btn-ghost btn-mono" style={{ fontSize: 10, padding: '0px 6px', flexShrink: 0, opacity: 0.5 }} onClick={e => handleCopy(e, String(value ?? ''))}>
        {copied ? '✓' : 'copy'}
      </button>
    </div>
  )
}
